import { render } from "./eConsent.vue?vue&type=template&id=8b9078a8&scoped=true"
import script from "./eConsent.js?vue&type=script&lang=js"
export * from "./eConsent.js?vue&type=script&lang=js"

import "./eConsent.vue?vue&type=style&index=0&id=8b9078a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9078a8"]])

export default __exports__